import script from "./tenant-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./tenant-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./tenant-form-drawer.vue?vue&type=style&index=0&id=595b1bd9&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595b1bd9"]])

export default __exports__